export const masalik = [
  "any",
  "deobandi",
  "ahlehadees",
  "barelvi",
];
